import { HTMLAttributes } from "react";

type ISvg = HTMLAttributes<SVGSVGElement>;

export const ArrowLeft = ({ ...props }: ISvg) => (
  <svg
    {...props}
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.82843 11.4999H20V13.4999H7.82843L13.1924 18.8638L11.7782 20.278L4 12.4999L11.7782 4.72168L13.1924 6.13589L7.82843 11.4999Z"
      fill="#f2f2f2"
    />
  </svg>
);
